import dayjs from "dayjs";
import { ExportOptionsFormState } from "src/features/observationsAdmin/components/ExportOptionsForm/ExportOptionsForm";

export const DEFAULT_EXPORT_OPTIONS: ExportOptionsFormState = {
	exportType: "Monthly" as const,
	quarter: undefined,
	month: dayjs().format("MMMM"),
	year: dayjs().year()
};

export const DEFAULT_ADMIN_OBSERVATION_QUESTION: AdminObservationQuestion = {
	id: null,
	order: 1,
	type: null,
	questionTypeId: null,
	question: "",
	note: "",
	goTo: null
};

export const DEFAULT_ADMIN_OBSERVATION_HEADING: AdminObservationQuestion = {
	id: null,
	order: 1,
	type: "HEADING",
	questionTypeId: 4,
	question: "",
	note: "",
	answers: [],
	goTo: null
};

export const DEFAULT_ADMIN_OBSERVATION_ANSWER: AdminObservationAnswer = {
	id: null,
	name: "",
	question: null,
	compliant: false,
	order: 1,
	value: "no"
};

export const DEFAULT_ADMIN_OBSERVATION_ANSWERS: AdminObservationAnswer[] = [
	{
		id: null,
		name: "",
		question: null,
		compliant: false,
		order: 1,
		value: "no"
	}
];

export const DEFAULT_ADMIN_GREAT_CONVERSATION_ANSWERS: AdminObservationAnswer[] =
	[
		{
			id: null,
			name: "",
			question: null,
			compliant: false,
			order: 1,
			value: ""
		}
	];

export const questionTypes: IAdminQuestionType[] = [
	{
		id: 1,
		name: "Text",
		enum: "TEXT"
	},
	{
		id: 2,
		name: "Radio Buttons",
		enum: "RADIO"
	},
	{
		id: 3,
		name: "Dropdown List",
		enum: "SELECT"
	},
	{
		id: 5,
		name: "Date",
		enum: "DATE"
	},
	{
		id: 4,
		name: "Heading",
		enum: "HEADING"
	},
	{
		id: 6,
		name: "Observation Date",
		enum: "OBSERVATION_DATE"
	},
	{ id: 7, name: "CC Email Recipient", enum: "CC_EMAIL_RECIPIENT" },

	{ id: 8, name: "Image Upload", enum: "IMAGE_UPLOAD" },

	{ id: 9, name: "Employee Selection", enum: "EMPLOYEE_SELECTION" }
];
